export const notValidIBANReasons = {
  notValidIBANFormat: "notValidIBANFormat",
  IBANNotInSepaList: "IBANNotInSepaList",
};
